import { IonAlert, IonContent, IonIcon, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel } from '@ionic/react'
import { createOutline, trashOutline } from 'ionicons/icons'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startEquipoUpdated } from '../../../actions/equipos'
import { setActiveLoading, startAddUnidadesMtoSwow, startAddUnidadesMtoHide } from '../../../actions/ui'
import { RootState } from '../../../reducers/rootReducer'

export const UnidadesItem: FC = () => {
  const dispatch = useDispatch();
  const { activeEquipo: { unidades } } = useSelector((state: RootState) => state.equipo);
  const { editUnidades } = useSelector((state: RootState) => state.ui);

  const handleDelete = () => {
    
  }
  const handleUpdate = () => {
    dispatch(startAddUnidadesMtoSwow())

  }
  return (
    <IonItem>
      <IonLabel className="item-label" position="stacked" color="primary">
        Unidades
      </IonLabel>
      <IonItemSliding>
        <IonItem lines="none">
          <IonLabel>{unidades}</IonLabel>
          {editUnidades && <UnidadesModal />}
        </IonItem>
        <IonItemOptions side="end" color="light">
          <IonItemOption color="light" onClick={() => { handleUpdate() }}><IonIcon className="icon-list" color="success" ariaLabel="Editar" title="Editar" icon={createOutline}></IonIcon></IonItemOption>
          <IonItemOption color="light" onClick={() => { handleDelete() }}><IonIcon className="icon-list" color="danger" icon={trashOutline}></IonIcon></IonItemOption>
        </IonItemOptions>
      </IonItemSliding>
    </IonItem>
  )
}

const UnidadesModal: FC = () => {
  const dispatch = useDispatch();
  const { editUnidades } = useSelector((state: RootState) => state.ui);
  const { activeEquipo } = useSelector((state: RootState) => state.equipo);

  const equipo = {
    tag: activeEquipo.tag,
    nombre_equipo: activeEquipo.nombre_equipo,
    descripcion_equipo: activeEquipo.descripcion_equipo,
    central: activeEquipo.central !== null ? activeEquipo.central._id : "",
    numero_equipo: activeEquipo.numero_equipo,
    type: activeEquipo.type,
    unidades: activeEquipo.unidades
  }
  const { unidades } = activeEquipo;

  const handleUpdate = ({ name }) => {
    dispatch(setActiveLoading());
    equipo.unidades = name
    dispatch(startEquipoUpdated(equipo));
    dispatch(startAddUnidadesMtoHide())
  };

  const handleClose = () => {
    dispatch(startAddUnidadesMtoHide());
  };
  return (
    <IonContent>
      <IonAlert
        isOpen={editUnidades}
        onDidDismiss={handleClose}
        header={'Unidades'}
        inputs={[
          {
            name: 'name',
            type: 'text',
            placeholder: 'Unidades',
            value: unidades
          },
        ]}
        buttons={[
          {
            text: 'Guardar',
            handler: (e) => {
              handleUpdate(e);
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              
            }
          }
        ]}
      />
    </IonContent>
  );
}
